import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from "../../contexts/LocalesContext";
import { MqttContext } from '../../contexts/MqttContext';
import LoadingComponent from "../../components/LoadingComponent";
import MessageComponent from "../../components/MessageComponent";
import ButtonComponent from "../../components/ButtonComponent";
import { getRequest } from "../../utils/requests";
import { secondsToPrettyTime } from "../../utils/data";
import { convertUnit } from '../../utils/converter'
import { unitaMisuraIntToString, getMachineParamsValue } from '../../utils/irriapp'

export default function PresetsScreen(props) {
  const { t } = useContext(LocalesContext);
  const [presets, setPresets] = useState(null);
  const { machineParams } = useContext(MqttContext);

  console.log(props)

  useEffect(() => {
    getRequest(
      props.apis.presets_index_api,
      {
        apis_auth_token: props.apis.auth_token,
        machine_uuid: props.machine_uuid,
      },
      (response) => {
        if (response.result) setPresets(response.payload.presets);
      }
    );
  }, []);

  return (
    <div>
      {presets ? (
        <>
          {presets.length ? (
            <>
              <div className="row row--end row--actions row--mb">
                <ButtonComponent
                  className="c-button"
                  label={t("application.cta.create_preset")}
                  onClick={() => props.goTo("editor", { type: "preset_new" })}
                />
              </div>
              <div className="c-table__responsive">
                <table className="c-table">
                  <thead>
                    <tr>
                      <th>{t("application.labels.name")}</th>
                      <th>
                        {t("irriapp.titles.work_mode")}
                      </th>
                      <th>{t("irriapp.titles.estimated_time")}</th>
                      <th>
                        {t("irriapp.labels.pause_start")}
                      </th>
                      <th>
                        {t("irriapp.labels.pause_end")}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {presets.map((preset) => {
                      return (
                        <tr key={preset.uuid}>
                          <th>
                            {preset.name}
                          </th>
                          <td>
                            {convertUnit(preset.params.work_mod, unitaMisuraIntToString(getMachineParamsValue(machineParams, 'conf_unita_misura')))}
                          </td>
                          <td>
                            {secondsToPrettyTime(preset.params.time_prevision)}
                          </td>
                          <td>
                            {preset.params.pause_start}{" "}
                            {t("application.units.minutes")}
                          </td>
                          <td>
                            {preset.params.pause_end}{" "}
                            {t("application.units.minutes")}
                          </td>
                          <td className="mobile">
                            <span><p>{t("application.labels.name")}</p><p>{preset.name}</p></span>
                            <span><p>{t("irriapp.titles.work_mode")}</p><p>{convertUnit(preset.params.work_mod, unitaMisuraIntToString(getMachineParamsValue(machineParams, 'conf_unita_misura')))}</p></span>
                            <span><p>{t("irriapp.titles.estimated_time")}</p><p>{secondsToPrettyTime(preset.params.time_prevision)}</p></span>
                            <span><p>{t("irriapp.labels.pause_start")}</p><p>{preset.params.pause_start}{" "} {t("application.units.minutes")}</p></span>
                            <span><p>{t("irriapp.labels.pause_end")}</p><p>{preset.params.pause_end}{" "} {t("application.units.minutes")}</p></span>
                          </td>
                          <td className="c-table__actions">
                            <div>
                              <ButtonComponent
                                icon="fas fa-edit"
                                className="button-icon"
                                onClick={() =>
                                  props.goTo("editor", {
                                    type: "preset_edit",
                                    params: preset.params,
                                    preset,
                                  })
                                }
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <MessageComponent
              title={t("application.messages.no_preset")}
              message={t("application.messages.no_preset_description")}
              extraContent={() => (
                <ButtonComponent
                  className="c-button"
                  label={t("application.cta.create_preset")}
                  onClick={() => props.goTo("editor", { type: "preset_new" })}
                />
              )}
            />
          )}
        </>
      ) : (
        <LoadingComponent semifullscreen />
      )}
    </div>
  );
}

PresetsScreen.propTypes = {
  goTo: PropTypes.func,
  machine_uuid: PropTypes.string.isRequired,
  apis: PropTypes.shape({
    auth_token: PropTypes.string.isRequired,
    presets_index_api: PropTypes.string.isRequired,
  }).isRequired,
};

PresetsScreen.defaultProps = {
  goTo: () => {},
};